<template>
    <div class="topics-list-container">
        <h2>Topics</h2>
        <TransitionGroup tag="div" name="fade" class="topicList">
            <UpdateTopicComponent v-for="topic, index in topics" :topic="topic" :key="topic.id" :index="index + 1"
                class="topic" :class="{ dragging: draggedTopic == topic }" @dragstart="dragStart($event, topic)"
                @dragend="dragEnd()" @dragover="dragOver(topic)">
            </UpdateTopicComponent>
        </TransitionGroup>
        <ButtonComponent type="submit" class="add-btn" @click.prevent="addTopic">
            Add
        </ButtonComponent>
    </div>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent.vue'
import UpdateTopicComponent from '@/components/UpdateTopicComponent.vue'

import axios from 'axios';

export default {
    name: 'TopicsList',
    components: {
        UpdateTopicComponent,
        ButtonComponent,
    },
    data() {
        return {
            editingTopic: null,
            draggedTopic: null,
            popupVisible: false,
            name: '',
            movingTopic: null,
            dragTimeout: null,
        }
    },

    methods: {
        async addTopic() {
            try {
                console.log(this.headers);
                await axios.post(
                    `${process.env.VUE_APP_BACKEND_URL}/topics`,
                    { topic: '', minutes: 0, seconds: 0, order_index: this.topics.length },
                    { headers: this.headers }
                )
            } catch (error) {
                console.log(error)
            }
        },
        dragStart($event, topic) {
            this.draggedTopic = topic
        },
        async dragOver(topic) {
            if (topic == this.draggedTopic) {
                return
            }
            if (topic == this.movingTopic) {
                return
            }
            this.movingTopic = topic
            clearTimeout(this.dragTimeout)
            this.dragTimeout = setTimeout(() => {
                let goForward = this.draggedTopic.order_index > topic.order_index
                let startIndex = Math.min(this.draggedTopic.order_index, topic.order_index)
                console.log("START:", startIndex)
                let endIndex = Math.max(this.draggedTopic.order_index, topic.order_index)
                console.log("END:", endIndex)
                let topics = this.topics.slice(startIndex - 1, endIndex)
                console.log(goForward)
                console.log(topics)
                let switchToIndex = topic.order_index
                for (let aTopic of topics) {
                    if (aTopic == this.draggedTopic) {
                        aTopic.order_index = switchToIndex
                        continue
                    }
                    if (goForward) {
                        aTopic.order_index += 1
                    } else {
                        aTopic.order_index -= 1
                    }
                }
                setTimeout(() => {
                    if (this.movingTopic == topic) {
                        this.movingTopic = null
                    }
                }, 300)
            }, 100)
        },
        dragEnd() {
            this.draggedTopic = null
            clearTimeout(this.dragTimeout)
            this.$store.dispatch('topics/updateAll')

        },
        async handleTopicUpdated() {
            this.editingTopic = null;
            this.popupVisible = false;
        },
        closePopup() {
            this.editingTopic = null;
            this.popupVisible = false;
        },
    },

    computed: {
        headers() {
            let headers = {}
            headers.session = this.$store.state.sessions.current.session_id
            return headers
        },
        token() {
            return this.$store.state.token
        },
        topics() {
            return [...this.$store.state.topics.all].sort((a, b) => a.order_index - b.order_index)
        },
    },
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/_variables.scss";

.topics-list-container,
.topicList {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.topic {
    &.dragging {
        opacity: .75;
        transform: scale(0.95);
    }
}

.topics-list-container {
    width: 100%;
    border-radius: 10px;

    h2 {
        line-height: 1;
        margin: 0;
    }

}

ul {
    list-style-type: none;
}

.buttons {
    transition: background-color 0.3s;
    text-align: center;
    color: $text-color;
    text-decoration: none;
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 1rem;
}

.topics-btn {
    border: none;
    padding: 0.5rem 1rem;
    font-size: 16px;
    border-radius: 5px;
    width: auto;
    cursor: pointer;
}


.btn-edit {
    background-color: $bubble-two-color;
    color: $text-color;
}

.btn-edit:hover {
    background-color: $bubble-two-color_light;
    color: $text-color_light;
}

.btn-delete {
    color: $color-red;
    background-color: $bubble-two-color;
}

.btn-delete:hover {
    background-color: $bubble-two-color_light;
    color: $color-light_red;
}


.popup-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $popup-background;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup {
    background-color: $bubble-two-color;
    padding: 2rem;
    border-radius: 10px;
}

.popup .btn-close {
    margin-top: 10px;
}

.btn-close {
    border: none;
    padding: 0.5rem 1rem;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    background: $bubble-color;
    margin-right: .5rem;
    color: $color-red;
    width: 100%;
}

.btn-close:hover {
    color: $color-light_red;
    background-color: $bubble-two-color;
}

/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: scaleY(0.01) translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
    position: absolute;
}
</style>
